module.exports = __webpack_public_path__ + "img/ecpat-logo.bf5421a7.svg";